import { FC, memo } from 'react';
import type { ReactNode } from 'react';
import type { Dayjs } from 'dayjs';
import { Select } from 'antd';
import { RANGE_PRESENT } from './constants';
import { Clinic } from '../../../../models/MedVox/Clinic';
import { RangeValue } from '../../../../hooks/components/useIncomingStatistics/types';
import { OptionLike } from '../../../../hooks/shared/useFilterOption';
import styles from './style.module.css';
import { ClinicSelect } from '../../../../components/shared/ClinicSelect';
import { FILTER_FIELD_TEXTS } from '../../../../components/shared/filterFieldTexts';
import { ResettableRangePicker } from '../../../../components/shared/ResettableRangePicker/ResettableRangePicker';
import type { ResettableRangeValue } from '../../../../components/shared/ResettableRangePicker/ResettableRangePicker';

interface Props {
  onClinicsChange: (e: string[]) => void;
  clinics: Clinic[];
  onRangePickerChange: (
    values: RangeValue<Dayjs>,
    formatString: string[],
  ) => void;
  dateRange: ResettableRangeValue;
  filterOption: (
    inputValue: string,
    option?: OptionLike | undefined,
  ) => boolean;
  clinicValue: string[];
  onOpenClinics: (value: boolean) => void;
  scenarioValue: string | null;
  scenarioOptions: Array<{ value: string; label: string }>;
  onScenarioChange: (value: string | undefined) => void;
  showTemplateFilter: boolean;
  campaignFilter?: ReactNode;
}

export const IncomingStatisticsFilter: FC<Props> = memo(
  ({
    onClinicsChange,
    clinics,
    onRangePickerChange,
    dateRange,
    clinicValue,
    filterOption,
    onOpenClinics,
    scenarioValue,
    scenarioOptions,
    onScenarioChange,
    campaignFilter,
  }: Props) => {
    const renderOption = (state: { label?: React.ReactNode }) => (
      <span className={styles.inputSpan}> {state.label}</span>
    );

    return (
      <>
        <div className={styles.filterBlock}>
          <div className={styles.inputsContainer}>
            <label>Период звонков</label>
            <ResettableRangePicker
              className={styles.dateInput}
              presets={RANGE_PRESENT}
              value={dateRange}
              onChange={onRangePickerChange}
            />
          </div>
          <div className={styles.inputsContainer}>
            <label>{FILTER_FIELD_TEXTS.notificationType.label}</label>
            <Select
              allowClear
              className={styles.input}
              placeholder={FILTER_FIELD_TEXTS.notificationType.placeholder}
              value={scenarioValue ?? undefined}
              filterOption={filterOption}
              onChange={onScenarioChange}
              showSearch
              options={scenarioOptions}
              autoClearSearchValue={false}
              optionRender={renderOption}
            />
          </div>
          <div className={styles.inputsContainer}>
            <label>{FILTER_FIELD_TEXTS.clinic.label}</label>
            <ClinicSelect
              clinics={clinics}
              value={clinicValue}
              onChange={onClinicsChange}
              className={styles.input}
              placeholder={FILTER_FIELD_TEXTS.clinic.placeholder}
              filterOption={filterOption}
              onOpenChange={onOpenClinics}
              optionRender={renderOption}
            />
          </div>
          {campaignFilter}
        </div>
      </>
    );
  },
);

IncomingStatisticsFilter.displayName = 'IncomingStatisticsFilter';
